var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-6"},[_c('div',_vm._l((_vm.availableFiles),function(file,index){return _c('div',{key:index,staticClass:"my-3"},[_c('Status',{attrs:{"id":file.id,"name":file.name,"status":file.status},on:{"removeFiles":function($event){return _vm.removeFiles(file)}}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }